import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

const placeList = async (velId, withStats = false) => {
  const url = `/api/abo/vel/${velId}/place${withStats ? "?stats=true" : ""}`;
  const { data } = await axiosInstance.get(url);

  // Ensure stats have default values if undefined
  if (withStats) {
    data.forEach(place => {
      place.stats = place.stats || { nb_products_enabled: 0, nb_products: 0, nb_products_missing_config: 0 };
    });
  }

  return data;
};

export const usePlaceList = ({ velId, withStats = false }) => {
  return useQuery({
    queryKey: ["vel", velId, "place", { withStats }],
    queryFn: () => placeList(velId, withStats),
    enabled: !!velId
  });
};
